/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frontrow_Point_4Inputs */

const en_frontrow_point_4 = /** @type {(inputs: Frontrow_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A problem reported with photos from the phone`)
};

/**
* | output |
* | --- |
* | "A problem reported with photos from the phone" |
*
* @param {Frontrow_Point_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const frontrow_point_4 = /** @type {((inputs?: Frontrow_Point_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frontrow_Point_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_frontrow_point_4(inputs)
});